import 'core-js/fn/number/is-nan';
import 'core-js/fn/string/repeat';
import 'core-js/fn/math/trunc';
import 'core-js/fn/math/sign';
import 'core-js/fn/string/starts-with';
import 'whatwg-fetch';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/assets/style/app.css';

import Vue from 'vue';
import { LayoutPlugin, NavbarPlugin } from 'bootstrap-vue';

import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;
Vue.use(LayoutPlugin);
Vue.use(NavbarPlugin);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
